module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Ka-Lb.5b14a042.png";